import { createSelector } from 'reselect';
import { ApplicationState } from '../store';

export const getAuthStore = (state: ApplicationState) => state.auth;

export const getTemporaryToken = createSelector(
  getAuthStore,
  (authStore) => authStore.sessionToken,
);

export const getAuthError = createSelector(getAuthStore, (authStore) => authStore.error);

export const getFinishRegister = createSelector(
  getAuthStore,
  (authStore) => authStore.finishRegister,
);
